import { faFileAlt, faFileVideo } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React from "react";
import { assetTypes, contentDefinitionId } from "./NomadSelect";
import { AcceptedGPSTypes } from "./OpenOrExtractFileDialog";

export const mediaType = {
  video: 2,
  text: 4,
};

const columns = {
  name: 1,
  duration: 2,
  author: 3,
  created: 4,
};

export async function findAssociatedGps(detail) {
  const gpsAsset =
    detail.relatedAssets &&
    detail.relatedAssets.find((related) => related.metadataType === 88);
  return (
    gpsAsset && {
      url: gpsAsset.fullUrl,
      name: gpsAsset.url.substring(gpsAsset.url.lastIndexOf("/") + 1),
    }
  );
}

export default class NomadFileList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      selectedFiles: [],
      loading: false,
      sort: { column: columns.name, ascending: true },
    };

    this.toggleColumnSort = this.toggleColumnSort.bind(this);
    this.selectFile = this.selectFile.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.acceptSelection = this.acceptSelection.bind(this);

    this.disabledActionButton = (
      <button type="button" className="button" disabled={true}>
        Accept
      </button>
    );
    this.actionButton = (
      <button type="button" className="button" onClick={this.acceptSelection}>
        Accept
      </button>
    );
  }

  componentDidMount() {
    this.refreshFileList();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.folderId !== prevProps.folderId ||
      this.props.searchTerm !== prevProps.searchTerm ||
      this.props.mediaType !== prevProps.mediaType
    ) {
      this.refreshFileList();
    }
  }

  setActionButton() {
    if (!this.props.multiSelect) {
      this.props.setActionButton(null);
    } else {
      this.props.setActionButton(
        this.state.selectedFiles.length > 0
          ? this.actionButton
          : this.disabledActionButton
      );
    }
  }

  async refreshFileList() {
    if (!this.props.folderId) return;

    this.setState({ loading: true, files: [], loadedFileCount: 0 });
    await this.getFilesPage(0);
  }

  async getFilesPage(pageOffset) {
    const filters = [
      {
        fieldName: "contentDefinitionId",
        operator: "Equals",
        values: contentDefinitionId,
      },
      {
        fieldName: "assetType",
        operator: "Equals",
        values: assetTypes.file,
      },
      {
        fieldName: "mediaType",
        operator: "Equals",
        values: this.props.mediaType ?? mediaType.video,
      },
    ];
    if (!this.props.searchTerm) {
      filters.push({
        fieldName: "parentId",
        operator: "Equals",
        values: this.props.folderId,
      });
    }

    const postData = {
      filters,
      returnedFieldNames: [
        "identifiers.createdDate",
        "identifiers.videoDuration",
        "identifiers.videoDurationDisplay",
        "identifiers.ownerName",
        "identifiers.ownerUsername",
        "identifiers.url",
        "identifiers.previewVideoFullUrl",
        "identifiers.parentId",
        "identifiers.displayPath",
      ],
      pageOffset,
      pageSize: 50,
    };
    if (this.props.searchTerm) {
      postData.searchQuery = this.props.searchTerm;
    }

    const response = await axios.post(
      //"https://app-api.nomad.mainroads.wa.gov.au/api/portal/search",
      `${this.props.nomadApiUrl}/api/portal/search`,
      postData,
      {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
        },
      }
    );

    const fileInfo = response && response.data;
    if (fileInfo) {
      var validItems =
        this.props.mediaType === mediaType.text
          ? fileInfo.items.filter((item) =>
              AcceptedGPSTypes.some((extension) =>
                item.title.toUpperCase().endsWith(extension)
              )
            )
          : fileInfo.items;
      this.setState(
        {
          files: [...this.state.files, ...validItems],
          loadedFileCount: this.state.loadedFileCount + fileInfo.items.length,
        },
        () => {
          if (fileInfo.totalItemCount > this.state.loadedFileCount)
            this.getFilesPage(pageOffset + 1);
          else this.setState({ loading: false });
        }
      );
    } else this.setState({ loading: false });
  }

  toggleColumnSort(e) {
    const column = parseInt(e.currentTarget.dataset.id);
    const ascending =
      this.state.sort.column === column ? !this.state.sort.ascending : true;
    this.setState({ sort: { column, ascending } });
  }

  headingClass(column, sortColumn) {
    return sortColumn === column
      ? this.state.sort.ascending
        ? "sortAscending"
        : "sortDescending"
      : null;
  }

  selectFile(e) {
    const { id, url, name } = e.currentTarget.dataset;
    if (this.props.multiSelect) {
      if (this.state.selectedFiles.includes(id)) {
        this.setState(
          {
            selectedFiles: this.state.selectedFiles.filter(
              (fileId) => fileId !== id
            ),
          },
          () => this.setActionButton()
        );
      } else {
        this.setState(
          { selectedFiles: [...this.state.selectedFiles, id] },
          () => this.setActionButton()
        );
      }
    } else {
      this.props.loadFiles([{ gps: { url, name } }]);
    }
  }

  selectAll() {
    if (this.state.files.length === this.state.selectedFiles.length) {
      this.setState({ selectedFiles: [] }, () => this.setActionButton());
    } else {
      this.setState(
        { selectedFiles: this.state.files.map((file) => file.id) },
        () => this.setActionButton()
      );
    }
  }

  async findAssociatedGps(fileId) {
    const response = await axios.get(
      `${this.props.nomadApiUrl}/api/asset/${fileId}/detail`,
      {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
        },
      }
    );

    const detail = response && response.data;
    if (detail) {
      return findAssociatedGps(detail);
    }
  }

  async acceptSelection() {
    const forVideo =
      (this.props.mediaType ?? mediaType.video) === mediaType.video;
    if (!forVideo) return;

    const selectedFiles = this.state.files.filter((file) =>
      this.state.selectedFiles.includes(file.id)
    );

    this.setState({ loading: true, selectedFiles: [] }, () =>
      this.setActionButton()
    );
    const withAttachedGps = await Promise.all(
      selectedFiles.map(async (file) => ({
        video: {
          id: file.id,
          url: file.identifiers.previewVideoFullUrl,
          name: file.title,
        },
        gps: await this.findAssociatedGps(file.id),
      }))
    );
    this.setState({ loading: false });
    this.props.loadFiles(withAttachedGps);
  }

  render() {
    const forVideo =
      (this.props.mediaType ?? mediaType.video) === mediaType.video;
    const sortColumn =
      this.state.sort.column === columns.duration && !forVideo
        ? columns.name
        : this.state.sort.column;
    const files = [...this.state.files].map((file) => ({
      ...file,
      createdDate: new Date(file.identifiers.createdDate),
    }));
    function textSort(a, b) {
      const itemA = (a ?? "").toUpperCase();
      const itemB = (b ?? "").toUpperCase();
      if (itemA < itemB) return -1;
      if (itemA > itemB) return 1;
      return 0;
    }
    function dateSort(a, b) {
      return a - b;
    }
    files.sort((file1, file2) => {
      const f1 = this.state.sort.ascending ? file1 : file2;
      const f2 = this.state.sort.ascending ? file2 : file1;
      switch (sortColumn) {
        case columns.duration:
          return textSort(
            f1.identifiers.videoDuration,
            f2.identifiers.videoDuration
          );
        case columns.author:
          return textSort(
            f1.identifiers.ownerName ?? f1.identifiers.ownerUsername,
            f2.identifiers.ownerName ?? f2.identifiers.ownerUsername
          );
        case columns.created:
          return dateSort(f1.createdDate, f2.createdDate);
        default:
          return textSort(f1.title, f2.title);
      }
    });

    return (
      <div className="nomad-filePanel">
        <div className="nomad-fileList">
          {this.state.loading ? (
            <div>Loading...</div>
          ) : (
            <table>
              <thead>
                <tr>
                  {this.props.multiSelect && this.state.files.length > 0 && (
                    <th style={{ width: "1em" }}>
                      <input
                        type="checkbox"
                        readOnly
                        checked={
                          this.state.files.length ===
                          this.state.selectedFiles.length
                        }
                        title="Select All"
                        onClick={this.selectAll}
                      />
                    </th>
                  )}
                  <th
                    data-id={columns.name}
                    onClick={this.toggleColumnSort}
                    className={this.headingClass(columns.name, sortColumn)}
                  >
                    Name
                  </th>
                  {forVideo && (
                    <th
                      data-id={columns.duration}
                      onClick={this.toggleColumnSort}
                      className={this.headingClass(
                        columns.duration,
                        sortColumn
                      )}
                    >
                      Duration
                    </th>
                  )}
                  <th
                    data-id={columns.author}
                    onClick={this.toggleColumnSort}
                    className={this.headingClass(columns.author, sortColumn)}
                  >
                    Author
                  </th>
                  <th
                    data-id={columns.created}
                    onClick={this.toggleColumnSort}
                    className={this.headingClass(columns.created, sortColumn)}
                  >
                    Created Date
                  </th>
                  {this.props.searchTerm && <th>Location</th>}
                </tr>
              </thead>
              <tbody>
                {files.map((file) => (
                  <tr
                    key={file.id}
                    className="fileItem"
                    data-id={file.id}
                    data-url={
                      forVideo
                        ? file.identifiers.previewVideoFullUrl
                        : file.identifiers.fullUrl
                    }
                    data-name={file.title}
                    onClick={this.selectFile}
                  >
                    {this.props.multiSelect && (
                      <td>
                        <input
                          type="checkbox"
                          readOnly
                          checked={this.state.selectedFiles.includes(file.id)}
                        />
                      </td>
                    )}
                    <td className="icon-left">
                      <FontAwesomeIcon
                        icon={forVideo ? faFileVideo : faFileAlt}
                        size="lg"
                      />
                      {file.title}
                    </td>
                    {forVideo && (
                      <td>{file.identifiers.videoDurationDisplay}</td>
                    )}
                    <td>
                      {file.identifiers.ownerName ??
                        file.identifiers.ownerUsername}
                    </td>
                    <td>{file.createdDate.toLocaleString()}</td>
                    {this.props.searchTerm && (
                      <td
                        className="nomad-folderLink"
                        data-id={file.identifiers.parentId}
                        onClick={this.props.navigateToFolder}
                      >
                        {file.identifiers.displayPath.substring(
                          file.identifiers.displayPath.indexOf("/") + 1,
                          file.identifiers.displayPath.lastIndexOf("/")
                        )}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {!this.state.loading && this.state.files.length > 0 ? (
          <div className="nomad-fileCount">
            {this.props.multiSelect
              ? `${this.state.selectedFiles.length} selected of ${this.state.files.length} files`
              : `${this.state.files.length} files`}
          </div>
        ) : null}
      </div>
    );
  }
}
